import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const createLeavePolicy = createAsyncThunk(
  "leave/create-policy",
  async (policyData, { rejectWithValue }) => {
    try {
      // Changed to POST and passed policyData as the request body
      const response = await axios.post(`${API_URL}/leave-configuration`, policyData);
      return response.data;
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "Failed to create Leave Policy";
      return rejectWithValue(msg);
    }
  },
);

export const getLeavePolicy = createAsyncThunk(
  "leave/get-policy",
  async (policyData, { rejectWithValue }) => {
    try {
      // Changed to POST and passed policyData as the request body
      const response = await axios.get(`${API_URL}/leave-configuration`);
      return response.data;
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "Failed to Get Leave Policy";
      return rejectWithValue(msg);
    }
  },
);

const leavePolicySlice = createSlice({
  name: "employeeLeavePolicy",
  initialState: {
    list: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearAuditError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLeavePolicy.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createLeavePolicy.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Optionally push the new policy into your list
        state.list.push(action.payload);
      })
      .addCase(createLeavePolicy.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

            .addCase(getLeavePolicy.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getLeavePolicy.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(getLeavePolicy.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearAuditError } = leavePolicySlice.actions;
export default leavePolicySlice.reducer;